import { observer } from 'mobx-react-lite';
import { CustomIcon, DeleteIcon, RectangleIcon } from '../../Globle/Icon';
import RectangleButton from '../../Globle/RectangleButton';
import { useMainContext } from '../../../hooks/useMainContext';
import { ButtonMode, ClosetMode } from '../../../config';
import { message } from 'antd';

const UnitsMapping = observer(() => {
    const { viewManager, closetManager, drawingManager } = useMainContext();
    const isDisabled = !viewManager.doUserHasAccess();
    const drawRectangleUnit = () => {
        if (isDisabled) return;
        if (drawingManager.isRectangleModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.prepareCanvasForDrawing();
        if (drawingManager.isDrawingModeOn && !drawingManager.isUnitModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDrawingMode(false);
        drawingManager.setDoorMode(false);
        drawingManager.setDrawingForm(false);
        drawingManager.setUnitMode(false);
        drawingManager.stopDrawing();
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
        drawingManager.setRectangleMode(true);
    };
    const drawUnit = () => {
        if (isDisabled) return;
        if (drawingManager.isUnitModeOn) {
            drawingManager.setUnitMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDrawingMode(false);
        drawingManager.setRectangleMode(false);
        drawingManager.stopDrawing();
        drawingManager.setDoorMode(false);
        drawingManager.setUnitMode(true);
        drawingManager.setDrawingForm(false);
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
    };
    const deleteUnit = () => {
        if (isDisabled) return;
        drawingManager.setDrawingForm(false);
        if (
            closetManager.closetMode === ClosetMode.DELETE &&
            viewManager.buttonMode != ButtonMode.Door
        ) {
            closetManager.setDeleteMode();
        } else {
            if (
                (viewManager.buttonMode == ButtonMode.Closet &&
                    closetManager.selectedPageCloset().length < 1) ||
                (viewManager.buttonMode == ButtonMode.Unit &&
                    closetManager.selectedPageUnit().length < 1)
            ) {
                if (viewManager.buttonMode == ButtonMode.Closet) {
                    message.error('Please Add a closet first');
                } else {
                    message.error('Please Add a unit first');
                }
                return;
            }
            drawingManager.setRectangleMode(false);
            drawingManager.setDrawingMode(false);
            closetManager.setObstacleForm(false);
            drawingManager.stopDrawing();
            closetManager.setDeleteMode();
        }
        if (viewManager.buttonMode == ButtonMode.Door) {
            viewManager.setButtonMode(ButtonMode.Closet);
            closetManager.setDeleteMode();
            drawingManager.setDrawingMode(false);
            closetManager.setObstacleForm(false);
            drawingManager.stopDrawing();
            closetManager.setDeleteMode();
        }
    };
    const unitButtons = [
        {
            icon: <CustomIcon />,
            label: 'Custom',
            onClick: () => {
                drawUnit();
            },
            isActive:
                (drawingManager.isDrawingModeOn &&
                    closetManager.units.length > 0) ||
                drawingManager.isUnitModeOn,
            className: 'h-[80px]',
            disabled: isDisabled,
        },
        {
            icon: <RectangleIcon />,
            label: 'Rectangle',
            onClick: () => {
                drawRectangleUnit();
            },
            isActive: drawingManager.isRectangleModeOn,
            className: 'h-[80px]',
            disabled: isDisabled,
        },
        {
            icon: <DeleteIcon />,
            label: 'Delete',
            onClick: () => {
                deleteUnit();
            },
            isActive:
                drawingManager.isDeleteMode &&
                viewManager.buttonMode != ButtonMode.Door,
            className: 'h-[80px]',
            disabled: isDisabled,
        },
    ];
    return (
        <div className="pt-[8px] grid grid-cols-3 gap-2 closest-mapping">
            {unitButtons.map((button, index) => (
                <RectangleButton
                    key={index}
                    Icon={button.icon}
                    label={button.label}
                    onClick={button.onClick}
                    isActive={button.isActive}
                    className={button.className}
                    disabled={button.disabled}
                />
            ))}
        </div>
    );
});

export default UnitsMapping;
